import React from 'react';

const RefundPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-extrabold text-gray-900">Refund Policy</h1>
      <div className="mt-6 prose prose-lg text-gray-500">
        <p>Once the registration is done there is no refund in our website.</p>
      </div>
    </div>
  );
};

export default RefundPolicy;
